import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { deleteSeriesType } from "../api/deleteSeriesType";

export const useDeleteSeriesType = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id) => deleteSeriesType(id),
    onSuccess: () => {
      toast.success("Deleted successfully.");
      queryClient.invalidateQueries({ queryKey: ["categoryAllSeries"] });
    },
    onError: () => {
      toast.error("Failed to delete. Please try again.");
    },
  });
};

